import { HiOutlineDocumentPlus } from 'react-icons/hi2'

const DocumentPlusIcon = () => {
  return <HiOutlineDocumentPlus className='w-5 h-5' />
}

export default DocumentPlusIcon
